import React, { useEffect, useState } from 'react'
import nbrApi from '../../../services/nbrApi'
import { Link, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import moment from 'moment'

function HouseKeepingStats() {
    const [data, setData] = useState([])
    const navigate = useNavigate()
    const [selectedProperty, setSelectedProperty] = useState({})
    const [selectedTimeFrame, setSelectedTimeFrame] = useState({})
    const [selectedScope, setSelectedScope] = useState({})
    const [properties, setProperties] = useState([])
    const [isLoading, setLoading] = useState(false)

    const timeframeOptions = [
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'this_week', label: 'This Week' },
        { value: 'this_month', label: 'This Month' },
        { value: 'last_week', label: 'Last Week' },
        { value: 'last_month', label: 'Last Month' },
    ]

    const scopeOptions = [
        { value: 'wip', label: 'Work in process' },
        { value: 'request', label: 'Request Level' },
        { value: 'room', label: 'Room Level' },
    ]

    // fetch data 
    async function fetchList() {
        setLoading(true)

        try {
            let payloadData = {
                properties_id: selectedProperty?.value?.toString(),
                timeframe: selectedTimeFrame?.value,
                scope: selectedScope?.value,
            }

            const response = await nbrApi.post(`/hk_stats?properties_id=${selectedProperty?.value}&timeframe=${selectedTimeFrame?.value}&scope=${selectedScope?.value}`, payloadData)
            let data = response?.data || []
            setData(data)
            setLoading(false)
        } catch (error) {
            console.error('Error fetching data:', error.message)
            setLoading(false)
        }
    }

    // properties list
    async function getPropertyDropdownData() {
        try {
            const response = await nbrApi.post('/listproperties')

            const data = response.data
            setProperties(data?.map(e => {
                return {
                    ...e,
                    value: e?.pk_id,
                    label: e?.property_name
                }
            }))
        } catch (error) {
            console.error(error)
        }
    }

    // Init
    useEffect(() => {
        getPropertyDropdownData()
        // fetchList()
    }, [])

    // property change
    const handlePropertyChange = (value) => {
        setSelectedProperty(value)
    }

    // handleTimeframe
    const handleTimeframe = (value) => {
        setSelectedTimeFrame(value)
    }
    // handleScope
    const handleScope = (value) => {
        setSelectedScope(value)
    }
    // search
    const handleSearch = async () => {
        if (selectedProperty?.value && selectedTimeFrame?.value && selectedScope?.value) {
            await fetchList()
        }
    }

    useEffect(() => {
        handleSearch()
    }, [selectedProperty, selectedScope, selectedTimeFrame])

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Housekeeping Stats</h4>
                    </div>
                    <div className="card-header d-block d-lg-flex justify-content-center align-items-center">
                        <div className='form-group'>
                            <label className='text-secondary'>Property : </label>
                            <Select
                                className='p-0 col-lg-3'
                                options={properties}
                                value={selectedProperty}
                                placeholder={'Select Property'}
                                onChange={(value) => handlePropertyChange(value)}
                                isSearchable
                                isDisabled={properties?.length === 0}
                                styles={customStyles}
                            />
                        </div>

                        <div className='form-group mx-o mx-lg-2'>
                            <label className='mt-3 mt-lg-0 text-secondary'>Timeframe : </label>
                            <Select
                                className='p-0 col-lg-3'
                                options={timeframeOptions}
                                value={selectedTimeFrame}
                                placeholder={'Select Timeframe'}
                                isSearchable
                                onChange={(value) => handleTimeframe(value)}
                                isDisabled={timeframeOptions?.length === 0}
                                styles={customStyles}
                            />

                        </div>

                        <div className='form-group mx-o mx-lg-2'>
                            <label className='mt-3 mt-lg-0 text-secondary'>Scope : </label>
                            <Select
                                className='p-0 col-lg-3'
                                options={scopeOptions}
                                value={selectedScope}
                                placeholder={'Select Scope'}
                                isSearchable
                                onChange={(value) => handleScope(value)}
                                isDisabled={scopeOptions?.length === 0}
                                styles={customStyles}
                            />

                        </div>
                        <div className='form-group' style={{ marginTop: 30 }}>
                            <button disabled={isLoading || !selectedProperty?.value || !selectedTimeFrame?.value || !selectedScope?.value}
                                type='button' className='mt-3 mt-lg-0 text-white btn btn-sm btn-primary'
                                onClick={handleSearch}>Submit</button>
                        </div>

                    </div>
                    <div className="card-body">
                        {data?.length === 0 &&
                            <p className='alert alert-primary fw-bold'>No Data available !</p>}
                        {!isLoading && data?.length > 0 && <div className="table-responsive dataTablehistory">
                            <div className="dataTables_wrapper no-footer">
                                <table id="example" className="table shadow-hover dataTable display">
                                    <thead>
                                        <tr className='text-left'>
                                            {selectedScope?.value === 'wip' &&
                                                (
                                                    <>
                                                        <th>ID</th>
                                                        <th>Property</th>
                                                        <th>Room</th>
                                                        <th>WIP Seconds</th>
                                                        <th>WIP Minutes</th>
                                                    </>
                                                )
                                            }
                                            {selectedScope?.value === 'scope' &&
                                                <th>Room</th>}
                                            <th>Room Tech</th>
                                            <th>Tracking Level</th>
                                            <th>Request Summary</th>
                                            <th>Work Mode</th>
                                            <th>Start Time</th>
                                            <th>End Time</th>
                                            {selectedScope?.value !== 'wip' &&
                                                <>
                                                    <th>Minutes</th>
                                                    <th>Status</th>
                                                </>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.map((item, index) => (
                                            <tr key={index} className='text-black text-capitalize text-left'>
                                                {selectedScope?.value === 'wip' && (
                                                    <>
                                                        <td>{item?.pk_id}</td>
                                                        <td>{item?.property_name}</td>
                                                        <td>{item?.room_number}</td>
                                                        <td>{item?.wip_seconds}</td>
                                                        <td>{item?.wip_minutes}</td>
                                                    </>
                                                )}

                                                {selectedScope?.value === 'scope' && <td>{item?.room_number}</td>}

                                                <td>{item?.room_tech}</td>
                                                <td>{item?.tracking_level}</td>
                                                <td style={{ maxWidth: 300, overflow: 'auto', textWrap: 'wrap' }}>{item?.request_summary}</td>
                                                <td>{item?.work_mode}</td>
                                                <td>{item?.start_time ? moment(item?.start_time).format('MMM Do YYYY, h:mm:ss A') : ''}</td>
                                                <td>{item?.end_time ? moment(item?.end_time).format('MMM Do YYYY, h:mm:ss A') : ''}</td>
                                                {selectedScope?.value !== 'wip' && (
                                                    <>
                                                        <td>{item?.minutes}</td>
                                                        <td>
                                                            <span className={`badge badge-${item?.status_val === 'completed' ? 'success' : item?.status_val === 'req no service' ? 'danger' : 'info text-black'}`}>
                                                                {item?.status_val}
                                                            </span>
                                                        </td>
                                                    </>
                                                )}

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div >
    )
}

// select style
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        width: '300px',
    }),
    menu: (provided, state) => ({
        ...provided,
        width: '300px', // Adjust the width as needed
    }),
};
export default HouseKeepingStats